//import HomeBranding from '../pages/HomeBranding'
//import HomeSass from '../pages/HomeSass'
//import HomeSoftware from '../pages/HomeSoftware'
const HomeSoftware = () => import('../pages/HomeSoftware.vue');
//import HomeStartUp from '../pages/HomeStartUp'
//import HomeAppLanding from '../pages/HomeAppLanding'
//import HomeShowcase from '../pages/HomeShowcase'
//import HomeEbook from '../pages/HomeEbook'
import HomeClinic from '../pages/HomeClinic'
//const HomeClinic = () => import('../pages/HomeClinic.vue')
//import HomePayment from '../pages/HomePayment'
//import HomeAgency from '../pages/HomeAgency'
//import HomeProductShowcase from '../pages/HomeProductShowcase'
//import ElementTabs from '../pages/elements/ElementTabs'
//import ElementAccordion from '../pages/elements/ElementAccordion'
//import ElementGradation from '../pages/elements/ElementGradation'
//import ElementBoxIcon from '../pages/elements/ElementBoxIcon'
//import ElementButtons from '../pages/elements/ElementButtons'
//import ElementCta from '../pages/elements/ElementCta'
//import ElementPopupVideo from '../pages/elements/ElementPopupVideo'
//import ElementPricingBox from '../pages/elements/ElementPricingBox'
//import ElementProgressBar from '../pages/elements/ElementProgressBar'
//import ElementProgressCircle from '../pages/elements/ElementProgressCircle'
//import ElementTeamMember from '../pages/elements/ElementTeamMember'
//import ElementTestimonial from '../pages/elements/ElementTestimonial'
//import ElementCounters from '../pages/elements/ElementCounters'
import NotFound from '../pages/elements/404'
import References from '../pages/References.vue'
import Download from '../pages/Download.vue'
import Contact from '../pages/Contact.vue'
import Faq from '../pages/Faq.vue'
import About from '../pages/About.vue'
import Services from '../pages/Services.vue'
import ik from '../pages/ik.vue'
import shop from '../pages/shop.vue'
import pricing from '../pages/pricing.vue'
import product from '../pages/product.vue'
import checkout from '../pages/checkout.vue'
import ItemListView from '../components/eCommerce/components/ItemListView.vue'
import ItemGridView from '../components/eCommerce/components/ItemGridView.vue'
import efatura from '../pages/eFatura.vue'
import privacy from '../pages/privacy.vue'
import termofuse from '../pages/termsofuse.vue'
import wheretofindus from '../pages/wheretofindus'
import login from "../pages/login/Login"
import register from "../pages/register/Register"
import blank from '../pages/Blank.vue'
import report from "../pages/report.vue"
import city from "../pages/city.vue"
import securepayment from "../pages/securepayment.vue"


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
        path:'/',
        name: 'HomeBranding',
        component: HomeSoftware,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Home', active: true },
            ],
            pageTitle: 'Barkod Sistemi | Karpin | Barkod Yazılım | Karpin | ERP | POS | Market Mağaza Toptan | Barkod Sistemi',
            rule: 'editor'
          }

        
    },
    // {
    //     path:'/sass',
    //     name: 'HomeSass',
    //     component: HomeSass
    // },
    {
        path:'/software',
        name: 'HomeSoftware',
        component: HomeSoftware
    },
    // {
    //     path:'/start-up',
    //     name: 'HomeStartUp',
    //     component: HomeStartUp
    // },
    // {
    //     path:'/app-landing',
    //     name: 'HomeAppLanding',
    //     component: HomeAppLanding
    // },
    // {
    //     path:'/Showcase',
    //     name: 'HomeShowcase',
    //     component: HomeShowcase
    // },
    // {
    //     path:'/ebook',
    //     name: 'HomeEbook',
    //     component: HomeEbook
    // },
    {
        path:'/clinic',
        name: 'HomeClinic',
        component: HomeClinic
    },
    // {
    //     path:'/payment',
    //     name: 'HomePayment',
    //     component: HomePayment
    // },
    // {
    //     path:'/agency',
    //     name: 'HomeAgency',
    //     component: HomeAgency
    // },
    // {
    //     path:'/product-showcase',
    //     name: 'HomeProductShowcase',
    //     component: HomeProductShowcase
    // },
    // {
    //     path:'/element-tab',
    //     name: 'ElementTabs',
    //     component: ElementTabs
    // },
    // {
    //     path:'/element-accordion',
    //     name: 'ElementAccordion',
    //     component: ElementAccordion
    // },
    // {
    //     path:'/element-gradation',
    //     name: 'ElementGradation',
    //     component: ElementGradation
    // },
    // {
    //     path:'/element-box-icon',
    //     name: 'ElementBoxIcon',
    //     component: ElementBoxIcon
    // },
    // {
    //     path:'/element-buttons',
    //     name: 'ElementButtons',
    //     component: ElementButtons
    // },
    // {
    //     path:'/element-cta',
    //     name: 'ElementCta',
    //     component: ElementCta
    // },
    // {
    //     path:'/element-popup-video',
    //     name: 'ElementPopupVideo',
    //     component: ElementPopupVideo
    // },
    // {
    //     path:'/element-pricing-box',
    //     name: 'ElementPricingBox',
    //     component: ElementPricingBox
    // },
    // {
    //     path:'/element-progress-bar',
    //     name: 'ElementProgressBar',
    //     component: ElementProgressBar
    // },
    // {
    //     path:'/element-progress-circle',
    //     name: 'ElementProgressCircle',
    //     component: ElementProgressCircle
    // },
    // {
    //     path:'/element-team-member',
    //     name: 'ElementTeamMember',
    //     component: ElementTeamMember
    // },
    // {
    //     path:'/element-testimonial',
    //     name: 'ElementTestimonial',
    //     component: ElementTestimonial
    // },
    
    // {
    //     path:'/element-counters',
    //     name: 'ElementCounters',
    //     component: ElementCounters
    // },
    {
    path:'/references',
    name: 'References',
    component: References,
    meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'References', active: true },
        ],
        pageTitle: 'references',
        rule: 'editor'
      }
    },
    {
        path:'/download',
        name: 'Download',
        component: Download,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Support', active: true },
            ],
            pageTitle: 'support',
            rule: 'editor'
          }
    },
    {
        path:'/contacts',
        name: 'Contacts',
        component : Contact,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Contact', active: true },
            ],
            pageTitle: 'contacts',
            rule: 'editor'
          }
    },
    {
        path:'/faq',
        name: 'Faq',
        component : Faq,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'S.S.S', active: true },
            ],
            pageTitle: 'faq',
            rule: 'editor'
          }
    },
    {
        path:'/about',
        name: 'About',
        component : About,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'About', active: true },
            ],
            pageTitle: 'about',
            rule: 'editor'
          }
    },
    {
        path:'/services',
        name: 'services',
        component : Services,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Services', active: true },
            ],
            pageTitle: 'services',
            rule: 'editor'
          }
    },
    {
        path:'/ik',
        name: 'ik',
        component : ik,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ik', active: true },
            ],
            pageTitle: 'ik',
            rule: 'editor'
          }
    },
    {
      path:'/city/:sPlaka/:sIl',
      name: 'city',
      component : city,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'il', active: true },
          ],
          pageTitle: 'il',
          rule: 'editor'
        }
  },
  {
    path:'/securepayment',
    name: 'securepayment',
    component : securepayment,
    meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'securepayment', active: true },
        ],
        pageTitle: 'securepayment',
        rule: 'editor'
      }
},
    {
        path:'/shop',
        name: 'shop',
        component : shop,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'shop', active: true },
            ],
            pageTitle: 'shop',
            rule: 'editor'
          }
    },
    {
      path:'/pricing',
      name: 'pricing',
      component : pricing,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'shop', active: true },
          ],
          pageTitle: 'shop',
          rule: 'editor'
        }
  },
    {
      path:'/urun/:item_id/:sSinifKodu/:sAciklama',
      name: 'product',
      component : product,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'product', active: true },
          ],
          pageTitle: 'product',
          rule: 'editor'
        }
  },
    {
      path:'/checkout',
      name: 'checkout',
      component : checkout,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'checkout', active: true },
          ],
          pageTitle: 'checkout',
          rule: 'editor'
        }
  },
  {
    path:'/ItemListView',
    name: 'ItemListView',
    component : ItemListView,
    meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'ItemListView', active: true },
        ],
        pageTitle: 'ItemListView',
        rule: 'editor'
      }
},
{
  path:'/ItemGridView',
  name: 'ItemGridView',
  component : ItemGridView,
  meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'ItemGridView', active: true },
      ],
      pageTitle: 'ItemGridView',
      rule: 'editor'
    }
},
{ 
  path: '/forms/form-wizard',
  name: 'extra-component-form-wizard',
  component: () => import('@/pages/forms/form-wizard/FormWizard.vue'),
  meta: {
    breadcrumb: [
      { title: 'Home', url: '/' },
      { title: 'Extra Components' },
      { title: 'Form Wizard', active: true }
    ],
    pageTitle: 'Form Wizard',
    rule: 'editor'
  }
}, 
{
  path: '/components/divider',
  name: 'component-divider',
  component: () => import('@/pages/components/vuesax/divider/Divider.vue'),
  meta: {
    breadcrumb: [
      { title: 'Home', url: '/' },
      { title: 'Components' },
      { title: 'Divider', active: true }
    ],
    pageTitle: 'Divider',
    rule: 'editor'
  }
}, 
    {
      path:'/efatura',
      name: 'efatura',
      component : efatura,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'efatura', active: true },
          ],
          pageTitle: 'efatura',
          rule: 'editor'
        }
  },
    {
        path:'/termsofuse',
        name: 'termsofuse',
        component : termofuse,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'termsofuse', active: true },
            ],
            pageTitle: 'termsofuse',
            rule: 'editor'
          }
    },
    {
        path:'/privacy',
        name: 'privacy',
        component : privacy,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'privacy', active: true },
            ],
            pageTitle: 'privacy',
            rule: 'editor'
          }
    },
    {
        path:'/wheretofindus',
        name: 'wheretofindus',
        component : wheretofindus,
        meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'wheretofindus', active: true },
            ],
            pageTitle: 'wheretofindus',
            rule: 'editor'
          }
    },
    {
      path:'/blank',
      name: 'blank',
      component : blank,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'blank', active: true },
          ],
          pageTitle: 'shop',
          rule: 'editor'
        }
  },
  {
    path:'/report/:sFisTipi/:nStokFisiID',
    name: 'report',
    component : report,
    meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'report', active: true },
        ],
        pageTitle: 'shop',
        rule: 'editor'
      }
},
    {
      path:'/login',
      name: 'login',
      component : login,
      meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'login', active: true },
          ],
          pageTitle: 'login',
          rule: 'editor'
        }
  },
  {
    path:'/register',
    name: 'register',
    component :register,
    meta: {
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'register', active: true },
        ],
        pageTitle: 'register',
        rule: 'editor'
      }
},
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
]
})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})
export default router